import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { createStructuredSelector } from 'reselect';

import { logoutUser } from 'app/ducks/authentication/actions';
import { IAuthenticationState } from 'app/types/state';

import FooterBar from './components/FooterBar';

const authentication = (state): IAuthenticationState => state.authentication;

export const selector = createStructuredSelector({ authentication });

export const actionCreators = {
  logoutUser,
};

interface IFooterProps {
  actions: any;
}

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class Footer extends React.Component<IFooterProps> {
  static defaultProps: IFooterProps = {
    actions: undefined,
  };

  render(): React.ReactNode {
    return (
      <FooterBar {...this.props} logoutUser={this.props.actions.logoutUser} />
    );
  }
}
